export default [
  {
    path: "/order/list/:type?",
    name: "MyOrder",
    meta: {
      title: "我的订单",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/MyOrder")
  },
  {
    path: "/order/logistics/:id",
    name: "Logistics",
    meta: {
      title: "物流信息",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/Logistics")
  },
  {
    path: "/order/detail/:id",
    name: "OrderDetails",
    meta: {
      title: "订单详情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/order/OrderDetails")
  },
  {
    path: "/order/submit/:id",
    name: "OrderSubmission",
    meta: {
      title: "提交订单",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/OrderSubmission")
  },
  {
    path: "/deposit/submit/:id",
    name: "DepositSubmission",
    meta: {
      title: "提交押金",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/DepositSubmission")
  },
  {
    path: "/review_deposit/submit/:id",
    name: "ReviewDepositSubmit",
    meta: {
      title: "提交审核支付",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/ReviewDepositSubmit")
  },
  {
    path: "/order/status/:id/:status",
    name: "PaymentStatus",
    meta: {
      title: "支付状态",
      keepAlive: true,
      auth: false
    },
    component: () => import("@views/order/PaymentStatus")
  },
  {
    path: "/order/refund/:id",
    name: "GoodsReturn",
    meta: {
      title: "申请退货",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/GoodsReturn.vue")
  },
  {
    path: "/order/refund_list",
    name: "ReturnList",
    meta: {
      title: "退货列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/ReturnList.vue")
  }
  ,
  {
    path: "/order/contract",
    name: "OrderContract",
    meta: {
      title: "电子合同",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/order/OrderContract.vue")
  },
  {
    path: "/order/alipay/withhold/launch",
    name: "AlipayWithholdLaunch",
    meta: {
      title: "支付宝代扣",
      keepAlive: false,
      backgroundColor: "#f5f5f5",
      auth: false
    },
    component: () => import("@views/order/AlipayWithholdLaunch.vue")
  }
];
